import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveIrrbbaFailure, saveIrrbbaSuccess, updateIrrbbaFailure, updateIrrbbaSuccess } from './actions';

export function* saveIrrbba({ payload }) {
  try {
    yield call(api.post, 'api/irrbba', payload.data, { withCredentials: true });

    yield put(saveIrrbbaSuccess());

    toast.success('IRRBBA criado com sucesso!')

    history.push('/specifications/pilar3/resources/irrbba');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveIrrbbaFailure());
  }
}

export function* updateIrrbba({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/irrbba/${id}`, payload.data, { withCredentials: true });

    yield put(updateIrrbbaSuccess());

    toast.success('IRRBBA atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/irrbba');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateIrrbbaFailure());
  }
}

export default all([
  takeLatest('@irrbba/SAVE_REQUEST', saveIrrbba),
  takeLatest('@irrbba/UPDATE_REQUEST', updateIrrbba)
]);